import {scrollIntoView} from "../../ui-components/light/scroll-into-view";
import {arrEquals}      from "../../utils/collections";
import {equalDeep}      from "../../utils/objects";
import {cs}             from "../chain-services";
import {Static}         from "../static";
import {UseState}       from "../use-state";

import {CsForm}               from "./cs-form";
import {FormErrorHighlighter} from "./form-error-highlighter";

export const Form2 = ({data, fields, onSubmit = undefined, showErrors = undefined, mustChange = undefined, next}) => cs(
    ["oriData", (_, next) => !mustChange ? next() : Static({
        getInitValue: () => data.value,
        next,
    })],
    ["showErrors", (_, next) => showErrors == null ? UseState({next}) : next({
        value: showErrors, onChange: () => {
        }
    })],
    ["submitting", (_, next) => UseState({next})],
    ["form", ({}, next) => CsForm({
        data,
        fields: normalizeFormFields(fields),
        next,
    })],
    ["refs", (_, next) => Static({getInitValue: () => [], next})],
    ["eh", (_, next) => FormErrorHighlighter({next})],
    ({form, showErrors, submitting, refs, oriData, eh}) => {
        const highlightErrors = () => {
            const field = form.fields1.find((field) => !field.valid && refs.find((r) => arrEquals(r.path, field.path) && r.dom))
            if (field) {
                scrollIntoView(refs.find((r) => arrEquals(r.path, field.path)).dom);
                eh.start(field.path);
            }
        };
        return next({
            ...form,
            invalid: !form.valid,
            looksValid: !submitting.value && (
                form.valid && !(mustChange && equalDeep(oriData, data.value)) || !showErrors.value
            ),
            data: data.value,
            showErrors: showErrors.value,
            highlightErrors: () => {
                if (!showErrors.value) {
                    showErrors.onChange(true);
                }
                highlightErrors();
            },
            ...(() => {
                const normalizePath = (path) => Array.isArray(path) ? path : path.split(".");
                const field = (path) => {
                    const field = form.field(path);
                    return {
                        ...field,
                        error: field.error && (
                            showErrors.value ||
                            field.error.failedValidator.alwaysShow
                        ) && field.error,
                        errCss: eh.errCss(path),
                        ref: (dom) => {
                            let r = refs.find((r) => arrEquals(r.path, path));
                            if (!r) {
                                r = {path};
                                refs.push(r);
                            }
                            r.dom = dom;
                        },
                        isRequired: () => !!field.validators?.find((v) => v.name === "required"),
                    };
                };
                const scope = (parentPath1) => {
                    const parentPath = normalizePath(parentPath1);
                    return ({
                        field: (path) => field([...parentPath, ...normalizePath(path)]),
                        scope: (path) => scope([...parentPath, ...normalizePath(path)]),
                    });
                };
                return scope([]);
            })(),
            submit: async ({onSubmit: onSubmit1 = undefined, onRejected = undefined} = {}) => {
                if (!(form.valid && !(mustChange && equalDeep(oriData, data.value)))) {
                    if (!showErrors.value) {
                        showErrors.onChange(true);
                    }
                    highlightErrors();
                    onRejected?.();
                    return;
                }

                if (submitting.value) {
                    return;
                }

                submitting.onChange(true);
                try {
                    await (onSubmit1 ?? onSubmit)({oriData, data: data.value});
                } finally {
                    submitting.onChange(false);
                }
            },
            submitting: submitting.value,
            oriData,
        });
    },
);

const normalizeFormFields = (fields) => {
    if (!fields || Array.isArray(fields)) {
        return fields;
    }
    return Object.keys(fields).map((path) => ({
        path: path.split("."),
        validators: fields[path],
    }))
};